import type { Locale } from 'date-fns';
import { enUS } from 'date-fns/locale/en-US';
import { it } from 'date-fns/locale/it';
import i18n from '../config/i18n';

const LOCALE_MAP: Record<string, string> = {
  it: 'it-IT',
  en: 'en-US',
};

const DATE_FNS_LOCALE_MAP: Record<string, Locale> = {
  it,
  en: enUS,
};

/**
 * Returns the Intl locale string for the current i18n language.
 * Falls back to the language code itself if not in the map.
 * Italian (it-IT) is the default when no language is detected.
 */
export function getLocale(): string {
  const lang = i18n.language ?? 'it';
  return LOCALE_MAP[lang] ?? lang;
}

/**
 * Returns the date-fns Locale object for the current i18n language.
 * Falls back to Italian locale if not in the map.
 */
export function getDateFnsLocale(): Locale {
  const lang = i18n.language ?? 'it';
  return DATE_FNS_LOCALE_MAP[lang] ?? it;
}
